module.exports = __webpack_public_path__ + "static/media/workforce_mangement.5ac486b8.webp";